import React, { useEffect, useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { apiRequest } from "../helpers/api";
import { SkeletonPage } from "../components/skeleton/Skeleton";
import { studioForPost, studioRoutes } from "../components/postStudio/postStudioUtils";

// The old /posts page was split into two studios. Older links (analytics, saved notifications)
// still use /posts?postId=…, so open that post's preview in whichever studio owns it.
const PostStudioRedirect = () => {
  const [searchParams] = useSearchParams();
  const postId = searchParams.get("postId");
  const [target, setTarget] = useState(postId ? null : studioRoutes.MANUAL.list);

  useEffect(() => {
    if (!postId) return undefined;
    let active = true;
    apiRequest(`/api/posts/${encodeURIComponent(postId)}`)
      .then((result) => { if (active) setTarget(`${studioForPost(result.post).list}?postId=${encodeURIComponent(postId)}`); })
      .catch(() => { if (active) setTarget(studioRoutes.MANUAL.list); });
    return () => { active = false; };
  }, [postId]);

  return target ? <Navigate to={target} replace /> : <SkeletonPage label="Opening post" />;
};

export default PostStudioRedirect;
